<div class="dialog-header">
  <h3 translate>add-new-service</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
    id="budgetModal-header-button-close"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="form" id="budgetModal-body-form-formFilter">
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-service" | translate }}</mat-label
        ><input
          formControlName="serviceName"
          maxlength="255"
          matInput
          id="budgetModal-form-input-serviceName"
          required
        />
        <mat-error
          translate
          *ngIf="form.get('serviceName').hasError('required')"
          >required-service</mat-error
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ labelServiceCarWorkshopPrice }}</mat-label
        ><input
          formControlName="carWorkshopPrice"
          matInput
          (input)="handleServiceCarWorkshopPrice()"
          mask="separator.2"
          [dropSpecialCharacters]="false"
          [allowNegativeNumbers]="false"
          [thousandSeparator]="getThousandSeparator()"
          separatorLimit="1000000000000000000"
          id="budgetModal-form-input-carWorkshopPrice"
          required
        />
        <mat-error
          translate
          *ngIf="form.get('carWorkshopPrice').hasError('required')"
          >required-price</mat-error
        >
      </mat-form-field>
    </div>
    <div class="row-fx-legacy">
      <mat-form-field *ngIf="!isCarWorkshopLogged()">
        <mat-label>{{ labelServiceClientPrice }}</mat-label
        ><input
          formControlName="clientPrice"
          matInput
          (input)="handleServiceClientPrice()"
          mask="separator.2"
          [dropSpecialCharacters]="false"
          [allowNegativeNumbers]="false"
          [thousandSeparator]="getThousandSeparator()"
          separatorLimit="1000000000000000000"
          id="budgetModal-form-input-clientPrice"
          required
        />
        <mat-error
          translate
          *ngIf="form.get('clientPrice').hasError('required')"
          >required-price</mat-error
        >
        <mat-error *ngIf="form.get('clientPrice').hasError('biggerOrEqual')"
          >{{ "required-bigger-or-equal" | translate }}
          {{ labelServiceCarWorkshopPrice }}</mat-error
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "input-amount-hours" | translate }}</mat-label
        ><input
          formControlName="amountOfHours"
          type="hidden"
          id="budgetModal-form-input-amountOfHours"
        />

        <mat-select
          matInput
          formControlName="selectedHoursService"
          (selectionChange)="setHours($event)"
          [value]="selectedHours"
          id="budgetModal-form-select-selectedHoursService"
        >
          <mat-option *ngFor="let hour of hours" [value]="hour.value">
            {{ hour.time }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "input-amount-minutes" | translate }}</mat-label
        ><mat-select
          formControlName="selectedMinutesService"
          matInput
          (selectionChange)="setMinutes($event)"
          [value]="selectedMinutes"
          id="budgetModal-form-select-selectedMinutesService"
        >
          <mat-option *ngFor="let minute of minutes" [value]="minute.value">
            {{ minute.time }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="toggles-grid">
      <div class="toggle-wrap">
        <mat-slide-toggle 
          formControlName="guarantee" 
          (change)="handleGuaranteeAndCourtesy($event)"
        >
          {{ "label-in-warranty" | translate }}
        </mat-slide-toggle>
      </div>
      <div class="toggle-wrap">
        <mat-slide-toggle 
          formControlName="courtesy" 
          (change)="handleGuaranteeAndCourtesy($event)"
        >
          {{ "label-in-courtesy" | translate }}
        </mat-slide-toggle>
        <div class="overlay"></div>
      </div>
    </div>
  </form>
</div>

<div class="dialog-actions">
  <button
    [disabled]="form.invalid"
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)"
    id="budgetModal-form-button-save"
  >
    {{ "input-save" | translate }}
  </button>
</div>
